<template lang="pug">
div.container-fluid
	.card
		.card-header Registro de mis horas
		.card-body
			.row
				.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
					.form-group
						label Filtra por usuario
						input-query(
							v-if="!filtro.usuario_ID"
							:realtime="true"
							url="gestion-horaria/php/api/query-usuarios.php"
							@selected="seleccionarUsuario($event)"
							inputClass="form-control"
							placeholder="Buscar por nombre"
						)
						.input-group(v-else)
							input.form-control(disabled, :value="filtro.usuarioNombre")
							.input-group-append
								button.btn.btn-danger(@click="quitarUsuario")
									span.fa.fa-trash
					.form-group.mt-2
						label Filtra por palabras
						input.form-control(v-model="filtro.descripcion", @keypress.enter="buscar")
				.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
					.row
						.col-xs-12.col-sm-12.col-md-12.col-lg-6.col-xl-6
							.form-group
								label Fecha de inicio
								datepicker(
									v-model="filtro.fechaInicio"
									:bootstrap-styling="true"
									:language="$dateLang"
									@selected="buscar()"
								)
						.col-xs-12.col-sm-12.col-md-12.col-lg-6.col-xl-6
							.form-group
								label Fecha de fin
								datepicker(
									v-model="filtro.fechaFin"
									:bootstrap-styling="true"
									:language="$dateLang"
									@selected="buscar()"
								)
				.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
					.form-group
						label Tipo de registro
						div
							.btn-group
								button.btn(
									@click="setTipoRegistro(null)"
									:class="(filtro.tipo_registro === null) ? 'btn-primary' : ''"
								) Todos
								button.btn(
									@click="setTipoRegistro('acumula')"
									:class="(filtro.tipo_registro === 'acumula') ? 'btn-primary' : ''"
								) Acumula
								button.btn(
									@click="setTipoRegistro('consume')"
									:class="(filtro.tipo_registro === 'consume') ? 'btn-primary' : ''"
								) Consume
					.form-group.mt-3
						label Estado
						div
							.btn-group
								button.btn(
									@click="setEstado(null)"
									:class="(filtro.estado === null) ? 'btn-primary' : ''"
								) Todos
								button.btn(
									@click="setEstado('validado')"
									:class="(filtro.estado === 'validado') ? 'btn-primary' : ''"
								) Validados
								button.btn(
									@click="setEstado('novalidado')"
									:class="(filtro.estado === 'novalidado') ? 'btn-primary' : ''"
								) Sin validar
		.card-footer
			button.btn.btn-primary(@click="buscar")
				span.fa.fa-search.mr-2
				| Buscar

	.row.mt-3
		.col-xs-12.col-sm-12.col-md-4.col-lg-3.col-xl-2
			.card
				.card-header.bg-dark.text-white
					span.fa.fa-users.mr-2
					| Resúmen
				table.table.table-striped.m-0
					thead
						tr
							th Empleado
							th Horas
					tbody
						tr(
							v-for="empleado in listadoEmpleados"
							:key="empleado.ID"
						)
							td.text-left {{empleado.nombre}} {{empleado.apellidos}}
							td.text-center {{empleado.horas}}
				
		.col-xs-12.col-sm-12.col-md-8.col-lg-9.col-xl-10
			.card
				.card-header.bg-info.text-white
					.row
						.col.text-left
							span.fa.fa-list.mr-2
							| Resultados
							button.btn.btn-danger.pull-right(
								v-if="filtro.usuario_ID && num_sin_validar > 0"
								@click="validarTodo"
							)
								span.fa.fa-check.mr-2
								| Validar Todo
				table.table.table-striped
					thead
						tr
							th ID
							th(style="min-width:100px;") Fecha
							th Usuario
							th Acumula
							th Consume
							th Descripcion
							th Aprueba
							th Detalles
							th Eliminar
					tbody
						tr(v-for="registro in registros", :key="registro.ID_registro")
							td {{registro.ID_registro}}
							td {{registro.fechaUnix | moment('DD-MM-YYYY')}}
							td.celdaUsuario(@click="detalleUsuario(registro.usuario_ID)")
								span(style="cursor:pointer;") {{registro.usuarioNombre}}
							td.text-center
								span(v-if="registro.tipo_registro === 'acumula'") +{{registro.horasRaw}}
							td.text-center
								span(v-if="registro.tipo_registro === 'consume'") {{registro.horasRaw}}
							td {{registro.descripcion}}
							td
								div(v-if="registro.aprobado")
									div {{registro.validadorNombre}}
									div(style="font-style:italic;") {{registro.aprobado}}
								div(v-else)
									button.btn.btn-warning(@click="validar(registro)")
										span.fa.fa-check.mr-2
										| Validar
							td
								button.btn.btn-primary(@click="verRegistro(registro)")
									span.fa.fa-eye.mr-2
									| Ver
							td
								button.btn.btn-danger(@click="eliminar(registro)")
									span.fa.fa-trash.mr-2
									| Eliminar
	detalle-usuario(v-if="detalle", @cerrar="detalle = null", :id-usuario="detalle")
</template>

<style>
	.form-group .vdp-datepicker .input-group > input {
	background-color: white !important;
	}
</style>

<script>
import API from '../api'
import DetalleUsuario from './detalleUsuario'
export default {
	components: {
		'detalle-usuario': DetalleUsuario
	},
	data () {
		return {
			filtro: {
				fechaInicio: new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0),
				fechaFin: new Date(new Date().getFullYear(), 11, 31, 23, 59, 59, 999),
				descripcion: null,
				tipo_registro: null,
				usuario_ID: null,
				usuarioNombre: null,
				estado: null
			},
			detalle: null,
			registros: [],
			listadoEmpleados: [],
			num_sin_validar: 0
		}
	},
	created () {
		this.buscar()
		this.getResumen()
	},
	methods: {
		getResumen () {
			API.getResumen()
				.then(res => {
					this.listadoEmpleados = res.data
				})
				.catch(this.$responseError)
		},
		seleccionarUsuario (ev) {
			this.filtro.usuario_ID = ev.data.ID
			this.filtro.usuarioNombre = ev.data.nombre + ' ' + ev.data.apellidos
			this.buscar()
		},
		quitarUsuario (ev) {
			this.filtro.usuario_ID = null
			this.filtro.usuarioNombre = null
			this.buscar()
		},
		detalleUsuario (idUsuario) {
			this.detalle = idUsuario
		},
		setTipoRegistro (tipo) {
			this.filtro.tipo_registro = tipo
			this.buscar()
		},
		setEstado (estado) {
			this.filtro.estado = estado
			this.buscar()
		},
		buscar () {
			const filtro = JSON.parse(JSON.stringify(this.filtro))
			filtro.fechaInicio = Math.floor(this.filtro.fechaInicio.getTime() / 1000)
			filtro.fechaFin = Math.floor(this.filtro.fechaFin.getTime() / 1000)

			API.getListado(filtro)
				.then(res => {
					this.registros = res.data.resultados
					this.num_sin_validar = res.data.num_sin_validar
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		verRegistro (registro) {
			this.$router.push('/main/horas-extra/editor/' + registro.ID_registro)
		},
		validarTodo () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Validar todos los registros',
				mensaje: `¿Quieres validar todos los registros pendientes de ` + this.filtro.usuarioNombre + `?`,
				callback: acepta => {
					if (acepta) {
						const filtro = JSON.parse(JSON.stringify(this.filtro))
						filtro.fechaInicio = Math.floor(this.filtro.fechaInicio.getTime() / 1000)
						filtro.fechaFin = Math.floor(this.filtro.fechaFin.getTime() / 1000)
						API.validarTodo(filtro)
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Registros validados'
								})
								this.buscar()
								this.getResumen()
							})
							.catch(e => {
								this.$store.commit('toast/danger', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},

		validar (registro) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Validar registro',
				mensaje: `¿Quieres validar este registro del usuario?`,
				callback: acepta => {
					if (acepta) {
						API.validar(registro.ID_registro)
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Registro validado'
								})
								this.buscar()
								this.getResumen()
							})
							.catch(e => {
								this.$store.commit('toast/danger', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},
		eliminar (registro) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar registro',
				mensaje: `¿Quieres eliminar este registro del usuario?`,
				callback: acepta => {
					if (acepta) {
						API.eliminar(registro.ID_registro)
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Registro eliminado'
								})
								this.buscar()
								this.getResumen()
							})
							.catch(e => {
								this.$store.commit('toast/danger', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		}
	}
}
</script>

<style scoped>
	td.celdaUsuario:hover {
		text-decoration: underline;
		color: darkblue;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/gestion-horaria/vue/listado/listado.vue